// @ts-nocheck
/* eslint-disable */
import * as types from 'appRedux/actions/segment';
import copy from 'utils/cloneObj';

const initialState = {
  loader: false,
  segments: [],
  subSegments: [],
  selectedSegmentId: null,
  form: {
    title: '',
  },
  searchText: '',
  showFormModal: false,
  showConfirmationModal: false,
  addSegmentSuccess: false,
  deleteSegmentSuccess: false,
  addSubSegmentSuccess: false,
  deleteSubSegmentSuccess: false,
  // updateSegmentSuccess: false,
};

function segmentReducer(state = initialState, action = {}) {
  switch (action.type) {
    case types.GET_SEGMENT_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_SEGMENT_SUCCESS:
      return {
        ...state,
        segments: action.payload.map((segment) => ({
          ...segment,
          value: segment.id,
          label: segment.title,
        })),
        loader: false,
      };

    case types.ADD_SEGMENT_REQUEST:
      return {
        ...state,
        addSegmentSuccess: false,
      };

    case types.ADD_SEGMENT_SUCCESS:
      return {
        ...state,
        addSegmentSuccess: true,
      };

    case types.GET_SEGMENT_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          title: action.payload.title,
        },
      };
    }

    case types.DELETE_SEGMENT_REQUEST:
      return {
        ...state,
        deleteSegmentSuccess: false,
      };

    case types.DELETE_SEGMENT_SUCCESS:
      return {
        ...state,
        deleteSegmentSuccess: true,
      };

    case types.GET_SUB_SEGMENT_REQUEST:
      return {
        ...state,
        loader: true,
      };

    case types.GET_SUB_SEGMENT_SUCCESS:
      return {
        ...state,
        subSegments: action.payload,
        loader: false,
      };

    case types.ADD_SUB_SEGMENT_REQUEST:
      return {
        ...state,
        addSubSegmentSuccess: false,
      };

    case types.ADD_SUB_SEGMENT_SUCCESS:
      return {
        ...state,
        addSubSegmentSuccess: true,
      };

    case types.GET_SUB_SEGMENT_BY_ID_SUCCESS: {
      return {
        ...state,
        form: {
          title: action.payload.title,
        },
      };
    }

    case types.DELETE_SUB_SEGMENT_REQUEST:
      return {
        ...state,
        deleteSubSegmentSuccess: false,
      };

    case types.DELETE_SUB_SEGMENT_SUCCESS:
      return {
        ...state,
        deleteSubSegmentSuccess: true,
      };

    case types.OPEN_FORM_MODAL:
      return {
        ...state,
        showFormModal: true,
      };

    case types.CLOSE_FORM_MODAL:
      return {
        ...state,
        showFormModal: false,
      };

    case types.OPEN_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: true,
        selectedSegmentId: action.payload.selectedSegmentId,
      };

    case types.CLOSE_CONFIRMATION_MODAL:
      return {
        ...state,
        showConfirmationModal: false,
        selectedSegmentId: null,
      };

    case types.UPDATE_FORM_FIELD:
      return updateFormField(state, action);

    case types.RESET_FORM_FIELD:
      return {
        ...state,
        form: {
          title: '',
        },
      };

    case types.UPDATE_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload.text,
      };

    default: {
      return state;
    }
  }
}

const updateFormField = (state, action) => {
  const {
    payload: { name, value },
  } = action;
  return {
    ...state,
    form: {
      ...state.form,
      [name]: value,
    },
  };
};
export default segmentReducer;
